import * as React from 'react';
import { createContext, useContext, useState } from 'react';
import { NotificationContextProps } from './types/notification-context-props';
import { NotificationType } from './types/notification-type';
import { Notification } from './types/notification';

export const NotificationContext = createContext<NotificationContextProps>(null!);

export function NotificationProvider(props: React.PropsWithChildren<unknown>) {
    const [notifications, setNotifications] = useState<Notification[]>(new Array<Notification>());

    const addNotification = (type: NotificationType, text: string, duration?: number) => {
        const newNotification = new Notification(text, type, duration);
        setNotifications((prevNotifications) => [...prevNotifications, newNotification]);
    };

    const context = {
        showSuccess: (text: string, duration?: number): void => {
            addNotification(NotificationType.Success, text, duration);
        },
        showError: (text: string, duration?: number): void => {
            addNotification(NotificationType.Error, text, duration);
        },
        showWarning: (text: string, duration?: number): void => {
            addNotification(NotificationType.Warning, text, duration);
        },
        showMessage: (text: string, duration?: number): void => {
            addNotification(NotificationType.Message, text, duration);
        },
        notifications,
    } as NotificationContextProps;

    return <NotificationContext.Provider value={{ ...context }}>{props.children}</NotificationContext.Provider>;
}

export function useNotification() {
    const context = useContext(NotificationContext);

    if (!context) {
        throw new Error('useNotification must be used within the NotificationContextProvider');
    }

    return context;
}
